import { render } from "./EditProvider.vue?vue&type=template&id=ae9d5494&ts=true"
import script from "./EditProvider.vue?vue&type=script&lang=ts"
export * from "./EditProvider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__